import {
  inboundShipmentProductIdFormat,
  shipmentDisputeIdFormat,
} from "@redotech/redo-model/ids";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";
import { DisputeStatus } from "./dispute-status";

const ShipmentDisputeSchema_ = z.object({
  id: shipmentDisputeIdFormat.schema,
  inboundShipmentProductId: inboundShipmentProductIdFormat.schema,
  status: createEnum(DisputeStatus),
  supplierEmail: z.string(),
  emailSubject: z.string(),
  emailBody: z.string(),
  damagedQuantity: z.number(),
  missingQuantity: z.number(),
  unitCost: z.number(),
  costCurrency: z.string(),
  sentAt: zExt.instant().nullable(),
  createdAt: zExt.instant(),
});

export const ShipmentDisputeSchema: z.ZodType<ShipmentDispute> =
  ShipmentDisputeSchema_;
export interface ShipmentDispute
  extends z.infer<typeof ShipmentDisputeSchema_> {}

export const createDispute = {
  name: "createDispute" as const,
  input: z
    .object({
      inboundShipmentProductId: inboundShipmentProductIdFormat.schema,
      supplierEmail: z.string().email(),
      emailSubject: z.string(),
      emailBody: z.string(),
      damagedQuantity: z.number().int().min(0),
      missingQuantity: z.number().int().min(0),
      unitCost: z.number(),
      costCurrency: z.string(),
    })
    .refine(
      (data) => data.damagedQuantity > 0 || data.missingQuantity > 0,
      "At least one of damagedQuantity or missingQuantity must be greater than 0",
    ),
  output: z.object({ dispute: ShipmentDisputeSchema }),
  files: true as const,
};
